import { useEffect, useState } from 'react'
import useTracking from './useTracking'

// trigger is for async data, once the data is ready, switch it to true and it'll send
const usePageView = (pageInfo?, trigger = true) => {
  const { tracker } = useTracking()
  const [hasSent, update] = useState(false)

  useEffect(() => {
    if (trigger && !hasSent) {
      tracker?.pageView(pageInfo || {})
      update(true)
    }
  }, [trigger])
}

export default usePageView
